// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p3-0";
export var leftAlign = "_p3-4";
export var listItem = "_p3-2";
export var listItemWrapper = "_p3-1";
export var operationText = "_p3-3";